import { isEmpty, last, replace, split } from 'lodash';

export const transformFormControlSelectedCountryToCountryCode = (country: string) => last(split(country, '.'));

export const sanitizeString = (value: string) => (!isEmpty(value) ? replace(value, /<[^>]+>/g, '') : value);

export const removeWhitespace = (value: string) => (!isEmpty(value) ? replace(value, /\s/g, '') : value);

export const trimWhitespace = (value: string) => (!isEmpty(value) ? replace(value, /^\s+|\s+$/g, '') : value);

export const numbersOnly = (value: string) => (!isEmpty(value) ? replace(value, /[^0-9]/g, '') : value);

export const removeHtmlMarkup = (value: string) => (!isEmpty(value) ? replace(value, /<(?:.|\n)*?>/gm, '') : value);
